const DAYS = [
  ["mon", "Mon"], ["tue", "Tue"], ["wed", "Wed"], ["thu", "Thu"],
  ["fri", "Fri"], ["sat", "Sat"], ["sun", "Sun"],
];

export const ScheduleEditor = ({ value, onChange }) => {
  const schedule = value || {};

  const setDay = (day, ranges) => onChange({ ...schedule, [day]: ranges });

  return (
    <div className="space-y-1.5">
      {DAYS.map(([key, label]) => {
        const ranges = schedule[key] || [];
        const open = ranges.length > 0;
        const [start, end] = ranges[0] || ["10:00", "22:00"];
        return (
          <div key={key} className="flex items-center gap-2 text-sm">
            <label className="w-20 flex items-center gap-2">
              <input type="checkbox" checked={open} data-testid={`schedule-${key}-toggle`}
                onChange={(e) => setDay(key, e.target.checked ? [[start, end]] : [])} />
              {label}
            </label>
            {open ? (
              <>
                <input type="time" value={start} className="border rounded px-2 py-1 text-xs"
                  onChange={(e) => setDay(key, [[e.target.value, end]])} />
                <span className="text-muted-foreground">–</span>
                <input type="time" value={end === "24:00" ? "23:59" : end} className="border rounded px-2 py-1 text-xs"
                  onChange={(e) => setDay(key, [[start, e.target.value === "23:59" ? "24:00" : e.target.value]])} />
              </>
            ) : (
              <span className="text-xs text-muted-foreground">Closed</span>
            )}
          </div>
        );
      })}
    </div>
  );
};
